import tw, { styled, css } from 'twin.macro';

export const StyledStatblock = styled.div<{ hasDropShadow: boolean }>`
  ${tw`flex flex-col`}
  ${tw`rounded lg:rounded-xl`}
  ${tw`p-2 lg:p-4`}
  ${tw`bg-neutrals-n1`}
  ${({ hasDropShadow }) =>
    hasDropShadow &&
    css`
      box-shadow: 0px 4px 8px 4px rgba(18, 110, 211, 0.15);
    `}
`;

export const StyledValue = styled.div<{ isLarge: boolean }>`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-secondary-s1`}
  ${({ isLarge }) =>
    isLarge
      ? tw`text-mobile-display-xxl lg:text-display-xxl`
      : tw` text-mobile-display-xl lg:text-display-xl`}
`;

export const StyledText = styled.div`
  ${tw`font-inter font-regular`}
  ${tw`text-body-l text-primary-p1`}
`;
